import { useEffect } from 'react';

export function usePageTitle(title) {
  useEffect(() => {
    document.title = title ? `${title} ⋅ POW Trading Portal` : 'POW Trading Portal';
    return () => { document.title = 'POW Trading Portal'; };
  }, [title]);
}
